export const ERROR_CODES = {
  common: 0,
}

export const MESSAGE_BY_ERROR_CODE = {
  [ERROR_CODES.common]: 'Something went wrong.',
}
